import { getSolarLenderNames, ITenant } from '@oneethos/shared'
import { ArrayEditor } from '../forms/array-editor'

type SolarLendersFormProps = {
  config: Partial<ITenant>
  setConfig: (config: Partial<ITenant>) => void
}

export const SolarLendersForm = ({ config, setConfig }: SolarLendersFormProps) => {
  const lenderNames = getSolarLenderNames(config.solarLenderNames)

  const setSolarLenderNames = (solarLenderNames: string[]) => {
    setConfig({ ...config, solarLenderNames })
  }

  return (
    <div className="tenant-config">
      <div className="form-group">
        <label className="form-label">Solar Lender Names</label>
        <ArrayEditor
          prompt="Add solar lender name"
          values={lenderNames}
          itemType="solar lender"
          onChange={setSolarLenderNames}
        />
      </div>
    </div>
  )
}
